import { atom } from 'jotai';
import { Cart } from '../api/models/cart';


export const cartAtom = atom<Cart | undefined>(undefined);
